<rt-icon *ngIf="showTalentPoolsIcon" name="talent-pools" size="small-x"></rt-icon>
